import { ajax } from '../index'

/**
 * scheme 相关接口
 */
export default {
  // 获取scheme数据
  getSchemeList(id: string, params: any) {
    return ajax.get('api', `/api/v1/scheme/${id}`, params)
  },
  // 获取面包屑数据
  getSchemeBreadcrumb(id: string) {
    return ajax.get('api', `/api/v1/breadcrumb/scheme/${id}`, {})
  },
  // 获取侧边栏数据
  getSchemeSidebar(id: string) {
    return ajax.get('api', `/api/v1/sidebar/filter/scheme?schemeID=${id}`, {})
  }
}